export default "__VITE_ASSET__Bdt4BCHb__"